<script setup lang="ts">
import type { PreviewItemData } from '@autobid/strapi-integration/typescript/auction/carPreview'
import type { AuctionCar } from '@autobid/ui/types/Car'
import CarNote from '@autobid/ui/components/common/dialog/CarNote.vue'
import { useNote } from '@autobid/ui/composables/car/useNote'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'
import { ref } from 'vue'

interface Props {
  car: AuctionCar | PreviewItemData
}

const props = defineProps<Props>()

const isNoteModalOpen = ref(false)

const { prefetch } = useNote(props.car.id, { enabled: false })
const {
  updateAuctionCar,
  updateBarometerCarData,
  updateDetailsCarData,
  updateSearchCar,
} = useUpdateCar()

async function handleOpen() {
  if (props.car.hasNote) {
    await prefetch()
  }
  isNoteModalOpen.value = true
}

function handleUpdate(hasNote: boolean) {
  updateAuctionCar(props.car.auctionId, props.car.id, (item) => {
    return {
      ...item,
      hasNote,
    }
  })

  updateSearchCar(props.car.id, (item) => {
    return {
      ...item,
      hasNote,
    }
  })

  updateBarometerCarData(props.car.auctionId, props.car.id, (item) => {
    return {
      ...item,
      hasNote,
    }
  })

  updateDetailsCarData(props.car.id, (item) => {
    return {
      ...item,
      hasNote,
    }
  })
}
</script>

<template>
  <CommonTooltip :tooltip="$t('cars-list.edit-note')" :class="$attrs.class">
    <DynamicAuctionItemListCarIcon
      :variant="car.hasNote ? 'primary' : 'border'"
      size="big"
      v-bind="$attrs"
      @click.stop="handleOpen"
      @mouseover="car.hasNote ? prefetch() : null"
    >
      <i class="ab-icon ab-icon-note h-full" />
    </DynamicAuctionItemListCarIcon>
  </CommonTooltip>

  <CarNote
    :is-open="isNoteModalOpen"
    :car-info="car.name"
    :car-id="car.id"
    :has-note="car.hasNote"
    @close="isNoteModalOpen = false"
    @update="handleUpdate"
  />
</template>
